import React, { useEffect, useState } from "react";
import API from "../api";

export default function Program() {
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    loadPrograms();
  }, []);

  const loadPrograms = async () => {
    try {
      // Gunakan endpoint getContentByType untuk ambil hanya type "program"
      const res = await API.get("/content/type/program");
      setPrograms(res.data);
    } catch (err) {
      console.error("Gagal load program:", err);
    }
  };

  return (
    <div className="container">
      <h1 className="text-center mb-4">📚 Program PAUD KB Cahaya Piradita Kaning</h1>

      {programs.length === 0 ? (
        <div className="card mb-4 p-3 text-center">
          <h3>📌 Program</h3>
          <p>Belum ada data program</p>
        </div>
      ) : (
        <div className="row">
          {programs.map((item) => (
            <div key={item.id} className="col-md-4 mb-4">
              <div className="card h-100 p-3">
                <h3>🎯 {item.title || "Program"}</h3>
                <p>{item.description || "Tidak ada deskripsi"}</p>
                {item.image && (
                  <img
                    src={`/uploads/${item.image}`}
                    alt={item.title}
                    className="img-fluid mt-2"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}